import React, { Fragment, useContext } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';

import { EntryContext } from '../contexts/entryContext';
import DisplayContent from '../utils/DisplayContent';
import InnerLayout from '../components/layouts/InnerLayout';
import GameOptions from '../components/GameOptions';

const GameList = () => {
    const { game, siteAssets } = useContext(EntryContext);

    return (
        <Fragment>
            <DisplayContent note='Top Banner' isVisible={game?.gameListBannerImage?.ref}>
                <div id='game-list-top-banner' className='top-banner'>
                    <img src={game?.gameListBannerImage?.ref} alt={game?.gameListBannerImage?.alt} />
                </div>
            </DisplayContent>

            <InnerLayout logo={true} banner={false} pageClass={`game-list`}>
                <Helmet>
                    <title>
                        {siteAssets?.gameListPageTitle ?? 'Games'} - {siteAssets?.title ?? 'Scratch Connect'}
                    </title>
                </Helmet>
                <GameOptions />
            </InnerLayout>

            <footer>
                <DisplayContent note='Game List Footer Callout' isVisible={game?.gameListFooterCallout?.ref}>
                    <div id='game-list-footer-callout' className='game-list-footer-callout'>
                        <img src={game?.gameListFooterCallout?.ref} alt={game?.gameListFooterCallout?.alt} />
                    </div>
                </DisplayContent>

                <DisplayContent note='Information button' isVisible={siteAssets?.features?.moreInfoPageEnabled}>
                    <Link id='game-list-information-button' role='button' to={`/information`}>
                        <img
                            src={game?.gameListInformationButton?.ref}
                            alt={game?.gameListInformationButton?.alt}
                            aria-label={game?.gameListInformationButton?.alt}
                        />
                    </Link>
                </DisplayContent>
            </footer>
        </Fragment>
    );
};

export default GameList;
